var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoFullscreenReverse = function SvgIcoFullscreenReverse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M13.3 10.714c.18.177.427.286.7.286h7a1 1 0 1 0 0-2h-4.586l5.293-5.293a1 1 0 0 0-1.414-1.414L15 7.586V3a1 1 0 1 0-2 0v7.003a1 1 0 0 0 .286.697zm-4.3 5.7V21a1 1 0 1 0 2 0v-7a.997.997 0 0 0-.997-1H3a1 1 0 1 0 0 2h4.586l-5.293 5.293a1 1 0 1 0 1.414 1.414z",
    clipRule: "evenodd"
  })));
};
export default SvgIcoFullscreenReverse;